import React from "react";
import { useNavigate } from "react-router-dom";
import "./Footer.css";
import logo from "../../../assets/Footer-Logo.svg";

const Footer = () => {
  const navigate = useNavigate();
  // const [showResourcesSubMenu, setShowResourcesSubMenu] = useState(false);

  // const handleResourcesHover = () => {
  //   setShowResourcesSubMenu(true);
  // };

  // const handleResourcesLeave = () => {
  //   setShowResourcesSubMenu(false);
  // };
  // window.scrollTo(0, 0);
  return (
    <div className="main-footer-container">
      <div className="footer-container">
        <div className="footer-part-1">
          <div className="footer-col-1">
            <img className="footer-logo" src={logo} alt="Logo" />
            <div className="footer-description">
              At Oyster, we are dedicated to elevating your writing and
              communication to new heights by providing a sophisticated writing
              assistance platform powered by AI. We're passionate about helping
              individuals, professionals, and students harness the power of
              words, express themselves with confidence, and achieve their
              goals. With cutting-edge technology and a commitment to
              excellence, we have become a trusted partner for those seeking to
              write more effectively, work efficiently, and communicate with
              impact. Join us in this journey towards clearer, more compelling,
              and more confident communication.
            </div>

            <button
              className="cta-button"
              onClick={(e) => {
                navigate("/new-sign-up");
              }}
            >
              Start for FREE
            </button>
          </div>
          <div className="footer-col-2">
            <div className="footer-menu-items">
              <div
                className="f-menu-item"
                onClick={() => {
                  navigate("/about");
                }}
              >
                Company
              </div>
              <div
                className="f-menu-item"
                onClick={() => {
                  navigate("/blogs");
                }}
              >
                Blogs
              </div>
              <div
                className="f-menu-item"
                onClick={() => {
                  navigate("/pricing");
                }}
              >
                Pricing
              </div>
              <div className="main-footer-menu">
                <span className="f-menu-item" onClick={() => navigate("/")}>
                  {" "}
                  Resources
                </span>
                <span
                  className="f-sub-menu-item"
                  onClick={() => {
                    navigate("/comparison");
                  }}
                >
                  {" "}
                  All Comparisions
                </span>
                <span
                  className="f-sub-menu-item"
                  onClick={() =>
                    (window.location.href = "https://appoyster.tawk.help/")
                  }
                >
                  Support Center
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-part-2">
          <div className="contact-details">
           MR-1, ALTF NOIDA 142, PLOT NO 21&21A, SECTOR 142, Gautam Buddha Nagar,{" "}
            <br />
            Noida, Uttar Pradesh, India, 201304
            <br />
            contact@appoyster.com
            <br />
            +91-7905505630
            <br />
          </div>
          <div className="privacy-links">
            <span
              className="cursor"
              onClick={() => {
                navigate("/privacy-policy");
              }}
            >
              {" "}
              Privacy Policy{" "}
            </span>
            |
            <span
              className="cursor"
              onClick={() => {
                navigate("/Terms-&-Conditions");
              }}
            >
              {" "}
              Terms & Condition{" "}
            </span>
            |
            <span
              className="cursor"
              onClick={() => {
                navigate("/Cancellation-&-Refund-Policy");
              }}
            >
              {" "}
              Cancellation & Refund Policy
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
